import React from "react";
import PageHeader from "../components/PageHeader";

export default function Advisory() {
  const breadcrumbs = [
    { label: "Home", link: "/" },
    { label: "Acts & Guidelines", link: "/acts" },
    { label: "Advisory / Recommendations", active: true },
  ];

  const recommendations = [
    {
      title: "Establishment of SUGAR BOARD in schools to monitor and reduce sugar intake among children",
      file: "Details 1.12 MB",
      date: "07-03-25",
      link: "#",
    },
    {
      title: "Display of Oil and Sugar Board in Ministry/Department/ Offices to promote Healthy Lifestyle and Combat Obesity and Non-Communicable Diseases.",
      file: "Details 1.38 MB",
      date: "08-07-25",
      link: "#",
    },
    {
      title: "Regarding use of minors for raising funds",
      file: "Details 55.91 KB",
      date: "07-12-22",
      link: "#",
    },
  ];

  return (
    <div>
      {/* Page Header */}
      <PageHeader
        title="Advisory / Recommendations"
        breadcrumbs={breadcrumbs}
      />

      {/* Timeline Section */}
      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="text-primary fw-bold mb-5 text-center">
            Advisory / Recommendations (NCPCR, Govt. of India)
          </h2>

          <div className="position-relative">
            {/* Vertical line */}
            <div className="position-absolute top-0 start-50 translate-middle-x w-1 bg-primary" style={{ height: "100%", width: "4px", borderRadius: "2px" }}></div>

            {/* Timeline items */}
            <div className="timeline position-relative">
              {recommendations.map((item, index) => (
                <div
                  key={index}
                  className={`row g-0 mb-5 align-items-center ${
                    index % 2 === 0 ? "flex-row-reverse" : ""
                  }`}
                >
                  <div className="col-md-6 d-flex justify-content-center">
                    <div className="card shadow-sm p-4 rounded-4 border-0 timeline-card">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <span className="badge bg-primary rounded-pill">
                          {index + 1}
                        </span>
                        <small className="text-muted">{item.date}</small>
                      </div>
                      <h5 className="text-primary fw-bold">{item.title}</h5>
                      <p className="text-secondary mb-3">{item.file}</p>
                      <a
                        href={item.link}
                        className="btn btn-outline-primary rounded-pill"
                      >
                        View
                      </a>
                    </div>
                  </div>
                  <div className="col-md-6"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
